











































import Vue from 'vue';

export default Vue.extend({
  props: {
    propietario: {
      type: Object,
      default: null,
    },
    unidad: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    openDialog: false,
    loading: false,
    unidadesPropietarios: [],
    unidadPropietarioSeleccionado: {},
  }),
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const datos = {admin, condo};
        console.debug('getUnidadesPropListMax datos: %o', datos);
        const response = await this.$store.dispatch('getUnidadesPropListMax', {datos});
        console.debug('getUnidadesPropListMax response: %o', response);
        this.unidadesPropietarios = response.content;
        for (const uniProp of this.unidadesPropietarios) {
          const label = uniProp.nombreUnidad + ' / ' + uniProp.nombreInquilino;
          uniProp.label = label;
        }
        this.assignPreselected();
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    assignPreselected() {
      let uniProp = {};
      if (this.unidad !== null) {
        uniProp = this.unidadesPropietarios.find((el) => el.unidadId === this.unidad.id);
      }
      if (this.propietario !== null) {
        uniProp = this.unidadesPropietarios.find((el) => el.propId === this.propietario.id);
      }
      if (uniProp === undefined) {
        this.unidadPropietarioSeleccionado = {};
      } else {
        this.unidadPropietarioSeleccionado = uniProp;
      }
    },
    async DisociarUnidadPropietario() {
      if (Object.keys(this.unidadPropietarioSeleccionado).length === 0) {
        this.$toast.warning('Seleccione una unidad/propietario');
        return;
      }
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const condominoUnidad = this.unidadPropietarioSeleccionado;
        const fecha = this.$moment().format();
        const datos = {admin, condo, condominoUnidad, fecha};
        console.log('disociarPropietCondo datos: ', datos);
        const response = await this.$store.dispatch('disociarPropietCondo', datos);
        console.log('disociarPropietCondo response: ', response);
        this.$toast.success('Unidad y propietario disociados exitosamente');
        this.unidadPropietarioSeleccionado = {};
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loadData();
    },
    closeDialog() {
      this.openDialog = false;
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        this.loadData();
      }
    },
  },
});
